import { GrClose } from "react-icons/gr";
import { useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import { t } from "../../../translations";
import { useLoginSignup } from "./useLoginSignup";
import LoginMethodSelect from "./steps/LoginMethodSelect";
import OtpStep from "./steps/OtpStep";
import "../../styles/navbar.css";

const LoginSignupDialog = ({ open, onClose }) => {
  const location = useLocation();
  const auth = useLoginSignup(open, onClose);

  const {
    email,
    setEmail,
    activeTab,
    setActiveTab,
    isSignUp,
    setIsSignUp,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    showPassword,
    setShowPassword,
    showConfirmPassword,
    setShowConfirmPassword,
    firstname,
    setFirstname,
    lastname,
    setLastname,
    phoneNumber,
    setPhoneNumber,
    otp,
    setOtp,
    showOtpStep,
    setShowOtpStep,
    otpLoading,
    load,
    setLoad,
    resetPasswordLoading,
    resetPasswordCooldown,
    errorLog,
    setErrorLog,
    selectedLang,
    validatePassword,
    sendOtp,
    verifyOtp,
    handlePasswordLogin,
    handlePasswordSignup,
    handlePasswordReset,
    handleGoogleLogin,
    handleAppleLogin,
    handleClose
  } = auth;

  if (!open || location.pathname === "/reset-password") {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className="log-in-up">
        <div className="log-in-up-title">
          <GrClose size={20} onClick={handleClose} />
          <span>{t("navbar.create_connect_account", selectedLang)}</span>
        </div>

        {!showOtpStep ? (
          <>
            <LoginMethodSelect
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              isSignUp={isSignUp}
              setIsSignUp={setIsSignUp}
              load={load}
              setLoad={setLoad}
              showOtpStep={showOtpStep}
              email={email}
              setEmail={setEmail}
              password={password}
              setPassword={setPassword}
              confirmPassword={confirmPassword}
              setConfirmPassword={setConfirmPassword}
              showPassword={showPassword}
              setShowPassword={setShowPassword}
              showConfirmPassword={showConfirmPassword}
              setShowConfirmPassword={setShowConfirmPassword}
              firstname={firstname}
              setFirstname={setFirstname}
              lastname={lastname}
              setLastname={setLastname}
              phoneNumber={phoneNumber}
              setPhoneNumber={setPhoneNumber}
              selectedLang={selectedLang}
              validatePassword={validatePassword}
              onGoogleLogin={handleGoogleLogin}
              onAppleLogin={handleAppleLogin}
              handlePasswordLogin={handlePasswordLogin}
              handlePasswordSignup={handlePasswordSignup}
              handlePasswordReset={handlePasswordReset}
              onSendOtp={sendOtp}
              resetPasswordLoading={resetPasswordLoading}
              resetPasswordCooldown={resetPasswordCooldown}
            />
            {errorLog && (
              <p style={{ fontSize: 18, margin: 10, color: "red" }}>{errorLog}</p>
            )}
          </>
        ) : (
          <OtpStep
            phoneNumber={phoneNumber}
            otp={otp}
            setOtp={setOtp}
            otpLoading={otpLoading}
            setShowOtpStep={() => {
              setShowOtpStep(false);
              setLoad(false);
            }}
            selectedLang={selectedLang}
            onVerifyOtp={verifyOtp}
            onResendOtp={sendOtp}
          />
        )}
      </div>
    </Dialog>
  );
};

export default LoginSignupDialog;
